import { Card, Chip as MuiChip, Grid, Stack, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

type CalendarTableInfoComponent = React.FC

const Chip = ({ label, bgColor }: { label: string; bgColor: string }) => {
    const theme = useTheme()

    return (
        <MuiChip
            label={label}
            sx={{
                height: 20,
                padding: 0,
                backgroundColor: bgColor,
                color: theme.palette.common.black,
            }}
        />
    )
}

export const CalendarTableInfo: CalendarTableInfoComponent = () => {
    const { t } = useTranslation()

    return (
        <Card
            sx={{
                marginTop: 4,
                marginBottom: 4,
                padding: 4,
            }}
        >
            <Typography
                sx={{
                    fontWeight: 800,
                    pb: 4,
                    fontSize: '16px',
                }}
            >
                {t('pages.calendar.legend.title')}
            </Typography>
            <Grid container spacing={4}>
                <Grid>
                    <Stack
                        direction='row'
                        spacing={1}
                        sx={{
                            alignItems: 'center',
                        }}
                    >
                        <Chip label={t('pages.calendar.chips.inc')} bgColor='#ffc100' />
                        <Typography>{t('pages.calendar.legend.incRights')}</Typography>
                    </Stack>
                </Grid>
                <Grid>
                    <Stack
                        direction='row'
                        spacing={1}
                        sx={{
                            alignItems: 'center',
                        }}
                    >
                        <Chip label={t('pages.calendar.chips.ex')} bgColor='#ff9a00' />
                        <Typography>{t('pages.calendar.legend.exRights')}</Typography>
                    </Stack>
                </Grid>
                <Grid>
                    <Stack
                        direction='row'
                        spacing={1}
                        sx={{
                            alignItems: 'center',
                        }}
                    >
                        <Chip label={t('pages.calendar.chips.tr')} bgColor='#d896ff' />
                        <Typography>{t('pages.calendar.legend.rightsEnd')}</Typography>
                    </Stack>
                </Grid>
                <Grid>
                    <Stack
                        direction='row'
                        spacing={1}
                        sx={{
                            alignItems: 'center',
                        }}
                    >
                        <Chip label={t('pages.calendar.chips.subscription')} bgColor='#8ecae6' />
                        <Typography>{t('pages.calendar.legend.subscription')}</Typography>
                    </Stack>
                </Grid>
                <Grid>
                    <Stack
                        direction='row'
                        spacing={1}
                        sx={{
                            alignItems: 'center',
                        }}
                    >
                        <Chip label={t('pages.calendar.chips.ipo')} bgColor='#a1d99b' />
                        <Typography>{t('pages.calendar.legend.ipo')}</Typography>
                    </Stack>
                </Grid>
            </Grid>
        </Card>
    )
}
